export default {
  logado:null,
}



// WEBPACK FOOTER //
// ./src/store/cliente/state.js